import IResult from '../api/types/result'
import IResultSet from '../api/types/resultSet'

// has the answer a value (the start date question: the process' start date)
export function isFilled(result: IResult, resultSet: IResultSet): boolean {
  if (!result) {
    return false
  }
  const { question, value } = result
  if (!question) {
    return false
  }

  // Special handling for start-date questions
  if (question.question_type === 'start_date') {
    return !!resultSet.start_date
  }

  switch (question.question_type) {
    case 'text':
    case 'checkbox':
    case 'real_checkbox':
    case 'number':
    case 'rating':
    case 'dropdown':
    case 'signature':
    case 'datetime':
    case 'external_email':
    case 'apicall':
    case 'person':
    case 'contact':
    case 'calculated_value':
    case 'site_code':
      return value && String(value).trim().length > 0
    case 'information':
      return true // 'information' type is always considered filled
    default:
      return true
  }
}
